<app-base-template (modal)="openModal(content)"(searchmodal) = "searchModal()"  (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [showSearch]="showSearch"[dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Add SLA Client Wise</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="prioritySelected"
              (change)="onPriorityChange($event.target.selectedIndex)">
        <option *ngFor="let priority of priorities" [value]="priority.id">{{priority.name}}</option>
      </select>
    </div>
   
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13"  [(ngModel)]="name"
               placeholder="Enter name">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13"  [(ngModel)]="desc"
               placeholder="Enter Description">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input class="form-control radius-0 font-13" 
               placeholder="Response Time in Minute" [(ngModel)]="respTime">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input class="form-control radius-0 font-13" 
               placeholder="Resolution Time in Minute" [(ngModel)]="resoTime">
      </div>
    </div>
    


    <div class="form-group matFrom" >
      <mat-form-field>
        <mat-label class="font-13">Select support group</mat-label>
        <mat-select [(ngModel)]="sgroupSelected" multiple>
          <mat-option *ngFor="let group of support_group" [value]="group.id" class="font-13">{{group.name}}</mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>



<ng-template #content1 let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Update SLA Client Wise</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

    <!-- <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
              (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>
    <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="prioritySelected"
              (change)="onPriorityChange($event.target.selectedIndex)">
        <option *ngFor="let priority of priorities" [value]="priority.id">{{priority.name}}</option>
      </select>
    </div> -->
    <div class="form-group" >
        <input type="text" class="form-control radius-0 font-13" [(ngModel)]="typeName" readonly>
      </div>
      <div class="form-group" >
          <input type="text" class="form-control radius-0 font-13" [(ngModel)]="priorityName" readonly>
      </div>
  
   
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13"  [(ngModel)]="name"
               placeholder="Enter name">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input type="text" class="form-control radius-0 font-13"  [(ngModel)]="desc"
               placeholder="Enter Description">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input class="form-control radius-0 font-13" 
               placeholder="Response Time in Minute" [(ngModel)]="respTime">
      </div>
    </div>
    <div class="form-group">
      <div class="form-group">
        <input class="form-control radius-0 font-13" 
               placeholder="Resolution Time in Minute" [(ngModel)]="resoTime">
      </div>
    </div>
    


    <div class="form-group matFrom">
      <mat-form-field>
        <mat-label class="font-13">Select support group</mat-label>
        <mat-select [(ngModel)]="sgroupSelected" multiple>
          <mat-option *ngFor="let group of support_group" [value]="group.id" class="font-13">{{group.name}}</mat-option>
        </mat-select>
      </mat-form-field>

    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="update()">Update</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>

  </div>
  <div class="modal-body">

      <div class="form-group mar_top">
          <input type="text" class="form-control radius-0 font-13" placeholder=" Enter Name "
                 [(ngModel)]="slaSelected">
      </div>
  </div>
  <div class="modal-footer pad-8">
          <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
          <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>

  </ng-template>
<notifier-container></notifier-container>


